


























































































import Vue from "vue";
import Component from "vue-class-component";
import api from "@/ts/functions";
import { IFeeVueModel } from "@/ts/models/IFeeVueModel";
import builder, { IVueStateCollection } from "@/ts/FormBuilder";
import CCDDActivitiesFacilityInfo from "@/views/reporting/CCDDActivities/FacilityInfo.vue";
import CCDDActivitiesMaterials from "@/views/reporting/CCDDActivities/Materials.vue";
import LiquidHazardousWasteFacilityInfo from "@/views/reporting/LiquidHazardousWaste/FacilityInfo.vue";
import LiquidHazardousWasteMaterials from "@/views/reporting/LiquidHazardousWaste/Materials.vue";
import NonResidentialHaulerFacilityInfo from "@/views/reporting/NonResidentialHauler/FacilityInfo.vue";
import NonResidentialHaulerMaterials from "@/views/reporting/NonResidentialHauler/Materials.vue";
import RecyclingActivitiesFacilityInfo from "@/views/reporting/RecyclingActivities/FacilityInfo.vue";
import RecyclingActivitiesMaterials from "@/views/reporting/RecyclingActivities/Materials.vue";
import ResidentialHaulerFacilityInfo from "@/views/reporting/ResidentialHauler/FacilityInfo.vue";
import ResidentialHaulerMaterials from "@/views/reporting/ResidentialHauler/Materials.vue";
import TransferStationFacilityInfo from "@/views/reporting/TransferStation/FacilityInfo.vue";
import TransferStationMaterials from "@/views/reporting/TransferStation/Materials.vue";
import Certification from "@/views/reporting/Certification.vue";

@Component({
    components: {
        CCDDActivitiesFacilityInfo, CCDDActivitiesMaterials,
        LiquidHazardousWasteFacilityInfo, LiquidHazardousWasteMaterials,
        NonResidentialHaulerFacilityInfo, NonResidentialHaulerMaterials,
        RecyclingActivitiesFacilityInfo, RecyclingActivitiesMaterials,
        ResidentialHaulerFacilityInfo, ResidentialHaulerMaterials,
        TransferStationFacilityInfo, TransferStationMaterials,
        Certification
    }
})
export default class ReportingReview extends Vue {
    name: string = "ReportingReview";
    isLoading: boolean = true;
    formData: any = { volumeFee: 0, fees: [], canHaveFees: false };
    vueStates: IVueStateCollection = { formType: "", formName: "", views: [], isRenewal: false };
    header: string = "";
    formType: string = "Reporting";
    formName: string = "";
    facilityInfo: string = "";
    materials: string = "";

    appDate: string = "";

    get isFormLoaded(): boolean {
        return !this.isLoading && this.formData !== undefined;
    }

    get total(): number {
        if (this.formData.fees.length > 0) {
            let value = 0;
            (this.formData.fees as IFeeVueModel[]).forEach(fee => value = value + fee.amount);
            return value;
        }
        return 0;
    }

    created(): void {
        this.formName = this.$route.params.formName;
        this.facilityInfo = `${this.formName}FacilityInfo`;
        this.materials = `${this.formName}Materials`;
        this.vueStates = builder.getViewStates(this.formType, this.formName, this.$props.isRenewal);
        this.header = builder.getFormHeader(this.formName);
    }

    mounted(): void {
        api.getForm(this.formType, this.formName, this.$route.params.applicationNumber)
            .then(result => this.formData = result)
            .finally(() => {
                this.setAppDate();
                this.$swal({
                    title: "Please review your application information.",
                    html: "If you need to make any changes click 'Revise' below.<br /> <br /> You must print the following summary page if you desire a receipt for your records. <br/><br />If you are ready to proceed click 'Checkout' to continue.",
                    type: "info"
                }).finally(() => this.isLoading = false);
            });
    }

    private setAppDate(): void {
        let date = new Date(this.formData.applicationDate);
        this.appDate = `${date.getMonth()+1}/${date.getDate()}/${date.getFullYear()}`;
    }

    checkout(): void {
        if (this.formData.canHaveFees) {
            if (this.formData.fees[0].amount > 0) {
                this.$router.push({ name: "Checkout", params: this.$route.params });
            } else {
                api.completeReport(this.$route.params.applicationNumber)
                    .then(res => {
                        this.$router.push({ name: "Checkout", params: this.$route.params });
                    });    
            }
        } else {
            api.completeReport(this.$route.params.applicationNumber)
                .then(res => {
                    this.$router.push({ name: "ThankYouNoFee", params: { formType: this.formName, applicationNumber: this.$route.params.applicationNumber } })
                });                
            //this.$router.push({ name: "ThankYou})
        }
    }

    edit(): void {
        this.$router.push({ name: this.formName, params: this.$route.params });
    }

    cancel(): void {
        this.$swal({
            title: "Cancel Checkout?",
            text: "You may return at any time to complete your application.",
            type: "question",
            showCancelButton: true,
            cancelButtonText: "Stay & Continue",
            confirmButtonText: "Cancel Checkout"
        }).then(result => {
            if (result.value) {
                this.$router.push({ path: "/" });
            }
        });
    }

}
